import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Shell from "../layout/Shell";
import { api, formatApiError } from "../lib/api";
import { EmptyState, ErrorBanner, LoadingCard, Pill } from "../lib/ui";

export default function Products() {
  const [state, setState] = useState({ loading: true, error: null, products: [] });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get("/products");
        if (cancelled) return;
        setState({ loading: false, error: null, products: res.data.products || [] });
      } catch (e) {
        if (!cancelled) setState((s) => ({ ...s, loading: false, error: formatApiError(e) }));
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <Shell title="Products">
      <div className="bo-eyebrow">Foundation</div>
      <h1 className="bo-serif" style={{ fontSize: 34, lineHeight: 1.1, letterSpacing: "-0.02em", margin: "6px 0 22px" }} data-testid="products-title">
        Products
      </h1>

      <ErrorBanner error={state.error} />
      {state.loading && <LoadingCard />}

      {!state.loading && state.products.length === 0 && (
        <EmptyState title="No products yet" description="Once seeded, The Well shows here." />
      )}

      <div style={{ display: "grid", gap: 16 }}>
        {state.products.map((p) => (
          <Link
            key={p.id}
            to={`/brand-os/products/${p.id}`}
            className="bo-card"
            data-testid={`product-card-${p.slug}`}
            style={{ display: "block", textDecoration: "none", color: "inherit" }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "start", gap: 16 }}>
              <div>
                <div className="bo-eyebrow">{p.slug}</div>
                <h2 className="bo-card-title" style={{ marginBottom: 4 }}>{p.name}</h2>
                <p style={{ color: "var(--bo-muted)", margin: 0 }}>{p.short_description}</p>
              </div>
              <Pill>{p.status}</Pill>
            </div>
          </Link>
        ))}
      </div>
    </Shell>
  );
}
